import { render, staticRenderFns } from "./StudentBasicPictureInfoView.vue?vue&type=template&id=1395c2c6&scoped=true"
import script from "./StudentBasicPictureInfoView.vue?vue&type=script&lang=js"
export * from "./StudentBasicPictureInfoView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1395c2c6",
  null
  
)

export default component.exports